import React from "react";

export default function TaxKnight() {
    const gamePath = "/webexport_Taxknight/Taxknight.html";
    return (
        <iframe src={gamePath} 
        className="w-full h-screen"
        title="Taxknight"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen/>
    )

}